import { Button } from "../../../../Components/ui/button";
import ButtonLoader from "../../../../Components/Loader";

const PrimaryButton = ({ title, onClick, loading = false, disabled = false }) => (
  <Button
    type="button"
    onClick={onClick}
    disabled={disabled || loading}
    className="h-12 rounded-lg bg-blueish text-white hover:bg-[#0052B4] disabled:opacity-50 disabled:cursor-not-allowed font-geomanistMedium text-base"
  >
    {loading ? <ButtonLoader /> : title}
  </Button>
);

export default PrimaryButton;
